function follow(link, title, role){
    alert(`Do you want to ${role} Sushant Naik on ${title}`)
    window.open(link)
}
export default follow;